import {
  MDBAutocomplete,
  MDBBtn,
  MDBSelect,
  MDBSpinner,
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { LocAddressSeach } from "../../../apiclients/streamsapi_bridge";
import { CANADA, USA } from "../../images";

function LocGeneralSettings({
  register,
  locationsList,
  statesList,
  billingGroups,
  defualtLocation,
  errors,
  setValue,
  getValues,
  watch,
  clearErrors,
}) {
  const { t, i18n } = useTranslation();
  // const [isloading, setIsloading] = useState(false);
  const [addressReasults, setAddressReasults] = useState([]);
  const [isDisplay, setisDisplay] = useState(false);
  const allowAPI = useRef(true);
  const [isLoading, setIsLoading] = useState(false);
  const [typingTimeout, setTypingTimeout] = useState(null);

  useEffect(() => {
    // Cleanup function to clear timeout when component unmounts or input value changes
    return () => {
      if (typingTimeout) {
        clearTimeout(typingTimeout);
      }
    };
  }, [typingTimeout]);

  function handleSearchAddressChange(searchValue) {
    try {
      clearErrors("general.street_addr1");
      setValue("general.street_addr1", searchValue, { shouldDirty: true });
      if (typingTimeout) {
        clearTimeout(typingTimeout);
      }
      const newTimeout = setTimeout(() => {
        sendApIRequest(searchValue);
      }, 500);
      // Update the typingTimeout state with the new timeout
      setTypingTimeout(newTimeout);
    } catch (error) {
      console.log(`Error in handleSearchAddressChange :::: ${error}`);
    }
  }

  const sendApIRequest = async (searchValue) => {
    try {
      if (searchValue.trim() !== "" && allowAPI.current) {
        //if (searchValue.trim() !== "") {
        let update = {
          reqid: 84,
          search: searchValue,
          siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        };
        setIsLoading(true);
        console.log("Request for the search :::::: " + JSON.stringify(update));
        const serverResponse = await LocAddressSeach(update);
        setIsLoading(false);
        if (!serverResponse.ok) {
          console.log("Network response was not ok");
          throw new Error("Network response was not ok");
        } else {
          const responseData = await serverResponse.json();
          console.log("Response Data:", JSON.stringify(responseData));
          let addressList = responseData?.message?.suggestions ?? [];
          setAddressReasults(addressList);
          if (addressList.length === 0) {
            setisDisplay(false);
          } else {
            setisDisplay(true);
          }
        }
      } else {
        allowAPI.current = true;
        setisDisplay(false);
      }
    } catch (error) {
      console.log(`Error in sendApIRequest for address search :::: ${error}`);
    }
  };

  function handleAddressSelect(address) {
     if(address.country) {
            setValue("country", address.country, { shouldDirty: true });
        }
    if (address.street_line) {
      // setaddressValue(address.street_line);
      setValue("general.street_addr1", address.street_line, {
        shouldDirty: true,
      });
    }
    if (address.secondary) {
      setValue("general.street_addr2", address.secondary, {
        shouldDirty: true,
      });
    }else{
      setValue("general.street_addr2", "", {
        shouldDirty: true,
      });
    }
    if (address.city) {
      setValue("general.city", address.city, { shouldDirty: true });
    }
    if (address.state) {
      const stateObj = statesList.find(
        (state) => state.statecode.trim() === address.state.trim()
      );
      console.log("stateObj :::::::: " + JSON.stringify(stateObj));
      if (stateObj) {
        setValue("general.state", parseInt(stateObj.stateid), {
          shouldDirty: true,
        });
      }
    }
    if (address.zipcode) {
      setValue("general.zip", address.zipcode, { shouldDirty: true });
    }
  }

  return (
    <>
      <div className="general-settings">{t("general")}</div>
      <div className="ps-0">
        <div className="add-numbermain">
          <div className="tel-numbers">{t("Name")}</div>
          <div className="flex-column-sm d-flex w-30">
            <div className="w-100">
              <input maxLength={50}
                type="text"
                className="w-100"
                {...register(`general.location_name`,{required : "Name is required"})}
              />
              {errors.general?.location_name && (
                <p className="text-danger">
                  {errors.general?.location_name.message}
                </p>
              )}
            </div>
          </div>
        </div>

        <div className="add-numbermain">
          <div className="tel-numbers">{t("Street Address 1")}</div>
          <div className="d-flex w-30">
            <div className="w-100">
              {/* <input
                type="text"
                {...register(`general.street_addr1`)}
                className="w-100"
              /> */}
              <MDBAutocomplete
                data={addressReasults}
                // value={addressValue}
                value={watch("general.street_addr1")}
                displayValue={(address) => address.street_line}
                isLoading={isLoading}
                // open={isDisplay}
                placeholder="Address 1"
                onSearch={handleSearchAddressChange}
                onSelect={(address) => {
                  allowAPI.current = false;
                  setisDisplay(false);
                  handleAddressSelect(address);
                }}
                itemContent={(address) => (
                  <div
                    onClick={(e) => {
                      e.preventDefault();
                      allowAPI.current = false;
                      handleAddressSelect(address);
                    }}
                  >
                    {address.country && (
                      <img
                        src={address.country === "USA" ? USA : CANADA}
                        className="me-3"
                        width={25}
                      />
                    )}
                    {address.street_line || ""}
                    {address.secondary ? ", " + address.secondary : ""}
                    {address.city ? ", " + address.city : ""}
                    {address.state ? ", " + address.state : ""}
                    {address.zipcode ? ", " + address.zipcode : ""}
                  </div>
                )}
              />
              {errors.general?.street_addr1 && (
                <p className="text-danger">
                  {errors.general?.street_addr1.message}
                </p>
              )}
            </div>
          </div>
        </div>
        <div className="add-numbermain">
          <div className="tel-numbers">{t("Street Address 2")}</div>
          <div className="d-flex w-30">
            <div className="w-100">
              <input
                type="text"
                // value="Suite, unit, bulding..."
                className="w-100"
                {...register(`general.street_addr2`)}
              />
              {errors.general?.street_addr2 && (
                <p className="text-danger">
                  {errors.general?.street_addr2.message}
                </p>
              )}
            </div>
          </div>
        </div>
        <div className="add-numbermain">
          <div className="tel-numbers">{t("City")}</div>
          <div className="d-flex w-30">
            <div className="w-100">
              <input
                type="text"
                className="selectname w-100"
                {...register("general.city")}
              />
              {errors.general?.city && (
                <p className="text-danger">{errors.general?.city.message}</p>
              )}
            </div>
          </div>
        </div>
        <div className="add-numbermain">
          <div className="tel-numbers">{t("State")}</div>
          <div className="d-flex w-30">
            <select
              className="w-100 m-0 form-select"
              value={watch("general.state")}
              search
              onChange={(e) => {
                e.preventDefault();
                setValue("general.state", parseInt(e.target.value), {
                  shouldDirty: true,
                });
              }}
            >
              {locationsList &&
                locationsList.length > 0 &&
                locationsList.map((state) => (
                  <option value={state.value}>{state.text}</option>
                ))}
            </select>
          </div>
        </div>
        <div className="add-numbermain">
          <div className="tel-numbers">{t("ZIP Code")}</div>
          <div className="d-flex w-30">
            <div className="w-100">
              <input
                type="text"
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                {...register("general.zip")}
                className="selectname w-100"
              />
              {errors.general?.zip && (
                <p className="text-danger">{errors.general?.zip.message}</p>
              )}
            </div>
          </div>
        </div>

        <div className="add-numbermain">
          <div className="tel-numbers">{t("Billing Group")}</div>
          <div className="phoneselect w-30">
            <select
              className="w-100 m-0 form-select"
              value={watch("general.billing_grp")}
              search
              onChange={(e) => {
                e.preventDefault();
                setValue("general.billing_grp", parseInt(e.target.value), {
                  shouldDirty: true,
                });
              }}
            >
              {billingGroups &&
                billingGroups.length > 0 &&
                billingGroups.map((grp) => (
                  <option value={grp.value}>{grp.text}</option>
                ))}
            </select>
            {/* <MDBSelect 
            data={statesList} 
            value={getValues("gereral.state")} 
            search  
            onChange={(e) => setValue("gereral.state", parseInt(e.value), {shouldDirty :  true})}
            /> */}
          </div>
        </div>

        {/* <div className="add-numbermain">
          <div className="tel-numbers">{t("Make Primary Location")}</div>
          <div className="phoneselect">
            <div className="phoneselect">
              <label className="switch">
                <input
                  className="form-control"
                  type="checkbox"
                  name="DefualtLocation"
                  disabled={getValues("general.make_def_loc")}
                  {...register("general.make_def_loc")}
                />
                <span className="slider round"></span>
              </label>
            </div>
          </div>
        </div> */}
      </div>
      {/* {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )} */}
    </>
  );
}

export default LocGeneralSettings;
